import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/ui/Header";
import Icon from "../../components/AppIcon";
import { useAuth } from "../../context/AuthContext";

const SignupPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { register, isLoading, isAuthenticated, role, getDefaultRedirectByRole } = useAuth();
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    companyName: "",
    password: "",
    confirmPassword: "",
  });
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");

    if (formData.password !== formData.confirmPassword) {
      setErrorMessage("Şifreler birbiriyle eşleşmiyor.");
      return;
    }

    try {
      const data = await register({
        fullName: formData.fullName.trim(),
        email: formData.email.trim(),
        companyName: formData.companyName.trim(),
        password: formData.password,
      });
      const nextPath = location?.state?.from || getDefaultRedirectByRole(data?.user?.role);
      navigate(nextPath, { replace: true });
    } catch (error) {
      setErrorMessage(error?.message || "Kayıt sırasında beklenmeyen bir hata oluştu.");
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate(getDefaultRedirectByRole(role), { replace: true });
    }
  }, [getDefaultRedirectByRole, isAuthenticated, navigate, role]);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-16 lg:pt-18">
        <section className="max-w-md mx-auto px-4 py-12">
          <div className="bg-surface border border-border rounded-xl shadow-elevation-2 p-6">
            <div className="mb-6 text-center">
              <div className="w-12 h-12 bg-primary-100 text-primary rounded-full flex items-center justify-center mx-auto mb-3">
                <Icon name="UserPlus" size={22} />
              </div>
              <h1 className="text-2xl font-semibold text-text-primary">Üye Ol</h1>
              <p className="text-sm text-text-secondary mt-1">
                AgroMart hesabını oluştur
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-text-primary mb-2" htmlFor="fullName">
                  Ad Soyad
                </label>
                <input
                  id="fullName"
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-border rounded-md bg-background text-text-primary focus:border-border-focus focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-text-primary mb-2" htmlFor="email">
                  E-posta
                </label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-border rounded-md bg-background text-text-primary focus:border-border-focus focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-text-primary mb-2" htmlFor="companyName">
                  Kurum Adı
                </label>
                <input
                  id="companyName"
                  type="text"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  required
                  className="w-full px-3 py-2 border border-border rounded-md bg-background text-text-primary focus:border-border-focus focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-text-primary mb-2" htmlFor="password">
                  Şifre
                </label>
                <input
                  id="password"
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  minLength={8}
                  required
                  className="w-full px-3 py-2 border border-border rounded-md bg-background text-text-primary focus:border-border-focus focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-text-primary mb-2" htmlFor="confirmPassword">
                  Şifre Tekrar
                </label>
                <input
                  id="confirmPassword"
                  type="password"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  minLength={8}
                  required
                  className="w-full px-3 py-2 border border-border rounded-md bg-background text-text-primary focus:border-border-focus focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
                />
              </div>

              {errorMessage && (
                <div className="text-sm bg-error-100 text-error rounded-md px-3 py-2">
                  {errorMessage}
                </div>
              )}

              <button
                type="submit"
                disabled={isLoading}
                className="w-full bg-primary text-white py-2.5 rounded-md font-medium hover:bg-primary-700 transition-all duration-200 disabled:opacity-70 disabled:cursor-not-allowed"
              >
                {isLoading ? "Kaydediliyor..." : "Üye Ol"}
              </button>
            </form>

            <div className="mt-4 text-sm text-center text-text-secondary">
              Zaten hesabınız var mı?{" "}
              <Link to="/login" className="font-medium text-primary hover:text-primary-700 transition-colors">
                Giriş Yap
              </Link>
            </div>
          </div>

        </section>
      </main>
    </div>
  );
};

export default SignupPage;
